import { SVGInternalIcon } from "@components:SVGInternalIcon";
import { Box, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";

interface SearchBoxProps {
  onKeyDown?: (e: any) => Promise<void>;
  onSearch?: (question?: string) => Promise<void>;
  isSearchDisable?: boolean;
  question?: string;
  setQuestion: (question: string) => void;
}

export const SearchBox = ({
  onKeyDown,
  onSearch,
  isSearchDisable,
  question,
  setQuestion,
}: SearchBoxProps) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <TextField
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={t("talk.searchPlaceholder")}
        variant="outlined"
        sx={{
          padding: "5px",
          width: "50%",
          borderRadius: 8,
          borderWidth: 0,
          input: {
            borderRadius: 7,
          },
          backgroundColor: "#EEEDF3",
          "&:hover": {
            backgroundColor: "#e3e2e8",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: 7,
            "&:hover fieldset": {
              borderWidth: 0,
              borderColor: "transparent !important",
            },
            fieldset: {
              borderWidth: 0,
            },
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: 0,
            borderColor: "transparent !important",
          },
        }}
      />
      <IconButton
        data-cy="btn-search-ai"
        size="large"
        sx={{
          backgroundColor: "#EEEDF3",
          borderRadius: "50%",
          marginLeft: "1rem",
          "&:hover": {
            backgroundColor: "#E0E0E0",
          },
        }}
        disabled={isSearchDisable}
        onClick={() => onSearch?.(question)}
      >
        <SVGInternalIcon
          icon="searchIcon"
          sx={{
            width: "28px",
            height: "28px",
            opacity: isSearchDisable ? "0.1" : "1",
          }}
        />
      </IconButton>
    </Box>
  );
};
